<template>
    <div class="orb-business-panel">
    <div class="border">

      <div class="header">
        <div class="header-text">
          <div class="pt-kicker">业务面板</div>
          <p class="card-title">{{ title }}</p>
        </div>
        <button class="close" @click="closeClick">&times;</button>
      </div>

      <!-- 内容主体 -->
      <div class="content-body">

        <!-- 工程总体进度 -->
        <div class="section-title">工程总体进度</div>
        <div class="progress-box">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: projectProgress + '%' }"></div>
          </div>
          <p class="progress-text">{{ projectProgress }}% 已完成</p>
        </div>

        <!-- 关键节点 -->
        <div class="section-title">关键里程碑节点</div>
        <table class="data-table">
          <tr>
            <th>节点名称</th>
            <th>计划时间</th>
            <th>实际时间</th>
            <th>状态</th>
          </tr>
          <tr v-for="item in milestones" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.plan }}</td>
            <td>{{ item.actual }}</td>
            <td :class="item.statusClass">{{ item.status }}</td>
          </tr>
        </table>

        <!-- 施工单位 -->
        <div class="section-title">施工单位信息</div>
        <table class="data-table">
          <tr>
            <th>单位名称</th>
            <th>负责人</th>
            <th>联系方式</th>
            <th>当前任务</th>
          </tr>
          <tr v-for="unit in contractors" :key="unit.name">
            <td>{{ unit.name }}</td>
            <td>{{ unit.manager }}</td>
            <td>{{ unit.phone }}</td>
            <td>{{ unit.task }}</td>
          </tr>
        </table>

        <!-- 设备安装进度 -->
        <div class="section-title">关键设备到货与安装进度</div>
        <table class="data-table">
          <tr>
            <th>设备名称</th>
            <th>到货状态</th>
            <th>安装完成度</th>
            <th>负责人</th>
          </tr>
          <tr v-for="equip in equipment" :key="equip.name">
            <td>{{ equip.name }}</td>
            <td>{{ equip.arrival }}</td>
            <td>{{ equip.install }}%</td>
            <td>{{ equip.person }}</td>
          </tr>
        </table>

        <!-- 质量与安全巡检 -->
        <div class="section-title">质量 / 安全巡检记录</div>
        <ul class="check-list">
          <li v-for="item in inspection" :key="item.date">
            <span class="check-date">{{ item.date }}</span>
            <span class="check-content">{{ item.content }}</span>
            <span :class="['check-status', item.levelClass]">{{ item.level }}</span>
          </li>
        </ul>

        <!-- 工程风险提示 -->
        <div class="section-title">工程风险提示</div>
        <ul class="risk-list">
          <li v-for="risk in riskList" :key="risk.title">
            <p class="risk-title">● {{ risk.title }}</p>
            <p class="risk-desc">{{ risk.detail }}</p>
          </li>
        </ul>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "projectManagement",
  data() {
    return {
      title:"工程管理",
      projectProgress: 46,  // 工程总体进度 %

      milestones: [
        { name: "施工准备完成", plan: "2024-01-15", actual: "2024-01-18", status: "已完成", statusClass: "green" },
        { name: "首段干渠开挖", plan: "2024-03-01", actual: "2024-03-05", status: "已完成", statusClass: "green" },
        { name: "泵站主体完工", plan: "2024-10-01", actual: "--", status: "进行中", statusClass: "blue" },
        { name: "输水管线贯通", plan: "2025-05-01", actual: "--", status: "未开始", statusClass: "yellow" }
      ],

      contractors: [
        { name: "中水工程建设有限公司", manager: "王建国", phone: "138-8888-1111", task: "泵站主体施工" },
        { name: "华源盾构集团", manager: "刘志强", phone: "136-6666-2222", task: "输水隧洞建设" },
        { name: "科建监理公司", manager: "陈伟", phone: "139-3333-4444", task: "工程监理" }
      ],

      equipment: [
        { name: "高压离心泵", arrival: "已到货", install: 40, person: "李明" },
        { name: "变频控制柜", arrival: "运输中", install: 0, person: "赵工" },
        { name: "水质在线监测装置", arrival: "已到货", install: 65, person: "周亮" }
      ],

      inspection: [
        { date: "2025-01-10", content: "泵站混凝土强度检测正常", level: "合格", levelClass: "green" },
        { date: "2025-01-18", content: "隧洞作业区安全带未规范使用", level: "需整改", levelClass: "yellow" },
        { date: "2025-01-22", content: "夜间值班记录不完整", level: "一般问题", levelClass: "blue" }
      ],

      riskList: [
        { title: "雨季可能导致基坑积水", detail: "需加强排水措施，提前布置临时排水泵站。" },
        { title: "设备到货延迟风险", detail: "变频柜运输时间不可控，需协调供应商加急处理。" }
      ]
    };
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    }
  }
};
</script>

<style scoped>

.border {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border-radius: 10px;
  margin-top: 0;
  padding: 18px;
  box-sizing: border-box;
  color: #eef7ff;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(99, 179, 237, 0.28);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.header-text {
  flex: 1;
}
.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.orb-business-panel {
  width: min(1040px, calc(100vw - 230px));
  height: calc(100vh - 150px);
  position: absolute;
  left: 50%;
  top: 112px;
  transform: translateX(-54%);
  z-index: 9998;
}

.content-body {
  color: #fff;
  font-size: 14px;
  padding: 10px 20px;
  height: calc(100% - 60px); /* 避免撑出 .border 区域，数值可依情况微调 */
  overflow-y: auto;
}

.section-title {
  font-size: 14px;
  margin-top: 16px;
  color: #fff;
  border-left: 4px solid rgba(56, 189, 248, 0.48);
  padding-left: 8px;
  font-weight: 700;
}

.data-table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
  color: #fff;
}
.data-table th {
  background: rgba(56, 189, 248, 0.1);
  padding: 8px;
  border: 1px solid rgba(255,255,255,0.08);
  color: #b8ecff;
  font-weight: 600;
}
.data-table td {
  padding: 8px;
  border: 1px solid rgba(255,255,255,0.04);
  color: rgba(255, 255, 255, 0.72);
}

.progress-box {
  margin: 10px 0;
}
.progress-bar {
  width: 100%;
  height: 5px;
  background: rgba(255,255,255,0.08);
  border-radius: 999px;
}
.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #38bdf8, #34d399);
  border-radius: 999px;
}
.progress-text {
  margin-top: 5px;
  color: #fff;
}

.green { color: #00ff9c; }
.blue { color: #00c3ff; }
.yellow { color: #ffd000; }

.check-list {
  margin-top: 8px;
  padding-left: 10px;
}
.check-list li {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}
.check-date { width: 90px; color: #ccc; }
.check-status.green { color: #00ff9c; }
.check-status.yellow { color: #ffd000; }
.check-status.blue { color: #00c3ff; }

.risk-list {
  margin-left: 10px;
}
.risk-title {
  font-weight: bold;
  color: #ffd000;
}
.risk-desc {
  margin-left: 12px;
  color: #ccc;
}

.close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}
</style>
